"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorderDiv = void 0;
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var __1 = require("..");
var __2 = require("../../../..");
var utils_1 = require("../../../../pages/utils/utils");
var Form_1 = __importDefault(require("../../Form"));
var SpolupracujiciOsoba_1 = __importDefault(require("../SpolupracujiciOsobyField/components/SpolupracujiciOsoba"));
var utils_2 = require("../utils");
var SelectTypOsoby_1 = __importDefault(require("../ZadavatelField/components/SelectTypOsoby"));
var PridatZadavateleField_1 = require("../ZadavatelField/PridatZadavateleField");
var PridatOsobyProfiluPopup_1 = require("./components/PridatOsobyProfiluPopup");
var PridatPodilejiciOsobuPopup_1 = require("./components/PridatPodilejiciOsobuPopup");
var PridatZpracovatelePopup_1 = __importDefault(require("./components/PridatZpracovatelePopup"));
var ZpracovatelListItem_1 = __importDefault(require("./components/ZpracovatelListItem"));
var StyledLabel = styled_components_1.default(function (props) { return react_1.default.createElement(__2.FormLabel, __assign({}, props)); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-self: flex-start;\n"], ["\n  align-self: flex-start;\n"])));
var StyledPopup = styled_components_1.default(function (props) { return react_1.default.createElement(__2.Popup, __assign({}, props)); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &-content {\n    padding: 2em 0 0 0;\n  }\n"], ["\n  &-content {\n    padding: 2em 0 0 0;\n  }\n"])));
var PopupChildren = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  max-height: 90vh;\n"], ["\n  max-height: 90vh;\n"])));
var StyledDiv = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-bottom: 1em;\n"], ["\n  margin-bottom: 1em;\n"])));
exports.BorderDiv = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var $hasError = _a.$hasError;
    return $hasError && styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      border: 2px solid #ba0d23;\n      border-radius: 4px;\n      height: auto;\n      padding-top: 12px;\n      padding-left: 2px;\n    "], ["\n      border: 2px solid #ba0d23;\n      border-radius: 4px;\n      height: auto;\n      padding-top: 12px;\n      padding-left: 2px;\n    "])));
});
var PopupDiv = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  max-height: 70vh;\n  overflow: auto;\n"], ["\n  max-height: 70vh;\n  overflow: auto;\n"])));
var PridatZpracovateleField = function (_a) {
    var _b, _c, _d, _e, _f;
    var name = _a.name, label = _a.label, datumZadani = _a.datumZadani, isEdit = _a.isEdit, isDodatek = _a.isDodatek;
    var isOpen = __2.useBoolean(false);
    var isPridatOsobyProfiluOpen = __2.useBoolean(false);
    var _g = formik_1.useField(name), field = _g[0], meta = _g[1], helpers = _g[2];
    var _h = formik_1.useField('spolupracujiciOsoba'), podilejiciField = _h[0], podilejiciHelpers = _h[2];
    var podilejiciValue = podilejiciField.value || [];
    var token = __2.useToken();
    var value = field.value || [];
    var _j = __2.useCiselnik('posudkyRole'), role = _j.data, loading = _j.loading, error = _j.error;
    var znalecLoad = __2.useBoolean(false);
    var clenstviLoad = __2.useBoolean(false);
    var _k = react_1.useState(undefined), selectedZpracovatel = _k[0], setSelectedZpracovatel = _k[1];
    var _l = react_1.useState(undefined), selectedKanclUstav = _l[0], setSelectedKanclUstav = _l[1];
    var _m = react_1.useState([]), znalciList = _m[0], setZnalciList = _m[1];
    var _o = react_1.useState([]), osobyProfiluList = _o[0], setOsobyProfiluList = _o[1];
    var _p = react_1.useState(), editIndex = _p[0], setEditIndex = _p[1];
    var _q = react_1.useState(), editValueZpracovatel = _q[0], setEditValueZpracovatel = _q[1];
    var adresaPlaceHolder = '';
    var apiUrl = __2.useConfig().apiUrl;
    var getZnalecClenstviJSON = __2.useGetJSON(apiUrl + "/ZnalecClenstvi/");
    var _r = react_1.useState('clenstvi'), activeTab = _r[0], setActiveTab = _r[1];
    var _s = (token === null || token === void 0 ? void 0 : token.getDataFromToken()) || {}, entityId = _s.entityId, roleIds = _s.roleIds, mandat = _s.mandat;
    var fopLogged = __2.isInRole([__2.Role.znalec], roleIds) && mandat === 'Znalec';
    var kancelarUstavLogged = __2.isInRole([__2.Role.znalec], roleIds) && (mandat === 'Znalecká kancelář' || mandat === 'Znalecký ústav');
    var editorLogged = false; // isInRole([Role.Editor], roleIds) && mandat === 'Interní pracovník';
    var getZnalecJSON = __2.useGetJSON(apiUrl + "/" + entityId);
    var primarniIdZkZu = react_1.useState((_b = value.filter(function (v) {
        var _a;
        return [
            __2.PosudkyRoleOsoby.ZpracovatelZnalecVRamciZKneboZU,
            __2.PosudkyRoleOsoby.ZpracovatelOsobaVedeckovyzkumnaCinnostRamciZKneboZU,
            __2.PosudkyRoleOsoby.ZpracovatelOsobaNezbytnaOdbornostVRamciZKneboZU,
        ].includes((_a = v === null || v === void 0 ? void 0 : v.role) === null || _a === void 0 ? void 0 : _a.id);
    })[0]) === null || _b === void 0 ? void 0 : _b.podiliSeJakoClen)[0];
    var getZnalec = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getZnalecClenstviJSON({ idZnalec: entityId })];
                case 1:
                    response = _a.sent();
                    if (__2.isRight(response))
                        return [2 /*return*/, response.value];
                    return [2 /*return*/, null];
            }
        });
    }); };
    var getKancelarUstav = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    znalecLoad.setTrue();
                    return [4 /*yield*/, getZnalecJSON()];
                case 1:
                    response = _a.sent();
                    if (__2.isRight(response)) {
                        znalecLoad.setFalse();
                        return [2 /*return*/, response.value];
                    }
                    return [2 /*return*/, null];
            }
        });
    }); };
    react_1.useEffect(function () {
        if (!isEdit && fopLogged) {
            getZnalec().then(function (res) {
                if (res && !res.jeClenem) {
                    var znalec = res.clenove[0];
                    var znalecValue = __assign({ idSubjekt: znalec === null || znalec === void 0 ? void 0 : znalec.idSubjektu, role: { id: __2.PosudkyRoleOsoby.Znalec }, druh: { id: __2.PosudkyTypOsoby.FyzickaOsobaPodnikajici }, znalecne: {} }, znalec);
                    helpers.setValue(__spreadArrays(value, [znalecValue]));
                }
            });
        }
        if (kancelarUstavLogged) {
            getKancelarUstav().then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
                var kanclUstav, kanclUstavValue;
                var _a;
                return __generator(this, function (_b) {
                    if (res) {
                        kanclUstav = res.znalec;
                        kanclUstavValue = __assign({ idSubjekt: kanclUstav === null || kanclUstav === void 0 ? void 0 : kanclUstav.id, role: { id: mandat === 'Znalecký ústav' ? __2.PosudkyRoleOsoby.ZnaleckyUstav : __2.PosudkyRoleOsoby.ZnaleckaKancelar }, druh: { id: __2.PosudkyTypOsoby.PravnickaOsoba }, adresaSidla: (_a = kanclUstav === null || kanclUstav === void 0 ? void 0 : kanclUstav.adresa) === null || _a === void 0 ? void 0 : _a.formatovanyText, znalecne: {} }, kanclUstav);
                        if (!isEdit)
                            helpers.setValue(__spreadArrays(value, [kanclUstavValue]));
                        setSelectedKanclUstav(kanclUstavValue);
                    }
                    return [2 /*return*/];
                });
            }); });
        }
    }, []);
    /* #11887
    const zapisujeZnalecne = (item: any) => {
      // prihlasena kancelar/ustav - znalec je clenem
      return item.role.id === PosudkyRoleOsoby.ZnalecPodilejiciNaZpracovani && item.podiliSeJakoClen.toString() === entityId ? item.znalecne || { platceDph: 1 } : undefined;
    }; */
    var handleAddZpracovatel = function (item, form) { return __awaiter(void 0, void 0, void 0, function () {
        var znalecneItem, changeId_1, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(item.role.id === __2.PosudkyRoleOsoby.Znalec)) return [3 /*break*/, 1];
                    znalecneItem = __assign(__assign({}, item), { znalecne: item.idSubjekt.toString() === entityId ? {} : undefined });
                    if (editIndex === undefined)
                        helpers.setValue(__spreadArrays(value, [znalecneItem]));
                    else {
                        changeId_1 = value[editIndex].idSubjekt;
                        podilejiciHelpers.setValue(podilejiciValue.filter(function (z) { return z.podiliSeJakoClen !== changeId_1; }));
                        value[editIndex] = znalecneItem;
                        helpers.setValue(value);
                    }
                    isOpen.setFalse();
                    return [3 /*break*/, 3];
                case 1:
                    setSelectedZpracovatel(item);
                    form.setSubmitting(true);
                    return [4 /*yield*/, getZnalecClenstviJSON({ idZnalec: item.idSubjekt })];
                case 2:
                    response = _a.sent();
                    form.setSubmitting(false);
                    if (__2.isRight(response))
                        setZnalciList(response.value.clenove);
                    else
                        form.setStatus({ message: response.value.message, type: 'error' });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onOpenOsobyProfilu = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isPridatOsobyProfiluOpen.setTrue();
                    clenstviLoad.setTrue();
                    return [4 /*yield*/, getZnalecClenstviJSON({ idZnalec: primarniIdZkZu !== null && primarniIdZkZu !== void 0 ? primarniIdZkZu : entityId })];
                case 1:
                    response = _a.sent();
                    clenstviLoad.setFalse();
                    if (__2.isRight(response)) {
                        setOsobyProfiluList(response.value.clenove);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onCloseOsobyProfilu = function () {
        isPridatOsobyProfiluOpen.setFalse();
        setEditIndex(undefined);
        setEditValueZpracovatel(undefined);
        setTimeout(function () {
            setOsobyProfiluList([]);
        }, 0);
    };
    var handleRemoveZpracovatel = function (id, index) {
        podilejiciHelpers.setValue(podilejiciValue.filter(function (o) { return o.podiliSeJakoClen !== id || o.role.id === __2.PosudkyRoleOsoby.Konzultant; }));
        helpers.setValue(value.filter(function (item) { return ramda_1.indexOf(item, value) !== index; }));
    };
    var handleDeleteSpolupracujiciOsoba = function (i) {
        var toRemove = kancelarUstavLogged || fopLogged
            ? podilejiciValue.filter(function (v) {
                var _a;
                return [
                    __2.PosudkyRoleOsoby.ZnalecPodilejiciNaZpracovani,
                    __2.PosudkyRoleOsoby.OsobaZapojenaDoVedeckovyzkumneCinnosti,
                    __2.PosudkyRoleOsoby.OsobaVeSluzebnimPomeru,
                    __2.PosudkyRoleOsoby.DalsiOsoba,
                ].includes((_a = v.role) === null || _a === void 0 ? void 0 : _a.id);
            })[i]
            : podilejiciValue[i];
        var filtered = podilejiciValue.filter(function (po) { return po !== toRemove; });
        if (toRemove.podiliSeJakoClen) {
            if (podilejiciValue.filter(function (po) { return po.podiliSeJakoClen === toRemove.podiliSeJakoClen; }).length < 2) {
                helpers.setValue(value.filter(function (z) { var _a; return (entityId !== ((_a = z.idSubjekt) === null || _a === void 0 ? void 0 : _a.toString()) ? z.idSubjekt !== toRemove.podiliSeJakoClen : z); }));
                filtered = filtered.filter(function (po) { return po.idSubjekt !== toRemove.podiliSeJakoClen; });
            }
            else
                helpers.setValue(value);
        }
        if (toRemove.role.id === __2.PosudkyRoleOsoby.ZnaleckaKancelarPodilejiciNaZpracovani || toRemove.role.id === __2.PosudkyRoleOsoby.ZnaleckyUstavPodilejiciNaZpracovani) {
            filtered = filtered.filter(function (po) { return po.podiliSeJakoClen !== toRemove.idSubjekt; });
        }
        podilejiciHelpers.setValue(filtered);
    };
    var handleEdit = function (i) {
        var _a;
        setEditIndex(i);
        var editZpracovatel = value[i];
        if (editZpracovatel.isOsobaProfilu ||
            entityId === String(editZpracovatel.podiliSeJakoClen) ||
            (isEdit && primarniIdZkZu === ((_a = editZpracovatel.podiliSeJakoClen) !== null && _a !== void 0 ? _a : editZpracovatel.idSubjekt))) {
            onOpenOsobyProfilu();
        }
        else {
            isOpen.setTrue();
        }
        setEditValueZpracovatel(editZpracovatel);
    };
    var podilejiciEditMode = function (i) { return __awaiter(void 0, void 0, void 0, function () {
        var updateValue, clenove, response, editOrganizace, clenove, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setEditIndex(i);
                    updateValue = kancelarUstavLogged || fopLogged || editorLogged
                        ? podilejiciValue.filter(function (v) {
                            var _a;
                            return [
                                __2.PosudkyRoleOsoby.ZnalecPodilejiciNaZpracovani,
                                __2.PosudkyRoleOsoby.OsobaZapojenaDoVedeckovyzkumneCinnosti,
                                __2.PosudkyRoleOsoby.OsobaVeSluzebnimPomeru,
                                __2.PosudkyRoleOsoby.DalsiOsoba,
                            ].includes((_a = v.role) === null || _a === void 0 ? void 0 : _a.id);
                        })[i]
                        : podilejiciValue[i];
                    if (updateValue.idSubjekt || updateValue.idExterniOsoba)
                        setActiveTab('clenstvi');
                    else
                        setActiveTab('adhoc');
                    if (!!updateValue.podiliSeJakoClen) return [3 /*break*/, 6];
                    if (!updateValue.idSubjekt) return [3 /*break*/, 4];
                    clenove = updateValue.clenove;
                    if (!!(clenove === null || clenove === void 0 ? void 0 : clenove.length)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getZnalecClenstviJSON({ idZnalec: updateValue.idSubjekt })];
                case 1:
                    response = _a.sent();
                    if (__2.isRight(response))
                        setZnalciList(response.value.clenove);
                    return [3 /*break*/, 3];
                case 2:
                    setZnalciList(clenove);
                    _a.label = 3;
                case 3:
                    setEditValueZpracovatel(updateValue);
                    return [3 /*break*/, 5];
                case 4:
                    setEditValueZpracovatel(__assign(__assign({}, updateValue), { jmeno: updateValue.jmeno, prijmeni: updateValue.prijmeni, adresaPobytu: updateValue.adresaPobytu, datumNarozeni: updateValue.datumNarozeni, titulPred: updateValue.titulPred ? updateValue.titulPred : undefined, titulZa: updateValue.titulZa ? updateValue.titulZa : undefined }));
                    _a.label = 5;
                case 5: return [3 /*break*/, 9];
                case 6:
                    editOrganizace = __spreadArrays(podilejiciValue, value).find(function (o) { return o.idSubjekt === updateValue.podiliSeJakoClen; });
                    setSelectedZpracovatel(editOrganizace);
                    setEditValueZpracovatel(editOrganizace);
                    clenove = editOrganizace.clenove;
                    if (!!(clenove === null || clenove === void 0 ? void 0 : clenove.length)) return [3 /*break*/, 8];
                    return [4 /*yield*/, getZnalecClenstviJSON({ idZnalec: editOrganizace.idSubjekt })];
                case 7:
                    response = _a.sent();
                    if (__2.isRight(response))
                        setZnalciList(response.value.clenove);
                    return [3 /*break*/, 9];
                case 8:
                    setZnalciList(clenove);
                    _a.label = 9;
                case 9:
                    isOpen.setTrue();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSetPodilejci = function (items) {
        var zpracovatelClenstvi = __assign(__assign({}, selectedZpracovatel), { clenove: znalciList, znalecne: selectedZpracovatel.idSubjekt.toString() === entityId ? selectedZpracovatel.znalecne || { platceDph: 1 } : undefined });
        var znalecneItems = items.map(function (i) {
            return __assign({}, i);
        });
        if (editIndex === undefined) {
            var filteredPodilejici = podilejiciValue.filter(function (v) { return v.podiliSeJakoClen !== items[0].podiliSeJakoClen; });
            podilejiciHelpers.setValue(__spreadArrays(filteredPodilejici, znalecneItems));
            var filteredZpracovatele = value.filter(function (v) { return v.idSubjekt !== zpracovatelClenstvi.idSubjekt; });
            helpers.setValue(__spreadArrays(filteredZpracovatele, [zpracovatelClenstvi]));
        }
        else {
            var changeId_2 = kancelarUstavLogged || fopLogged ? editValueZpracovatel.idSubjekt : value[editIndex].idSubjekt;
            var znalecnePodilejici = podilejiciValue.map(function (i) {
                return __assign({}, i);
            });
            podilejiciHelpers.setValue(__spreadArrays(znalecnePodilejici.filter(function (z) { return z.podiliSeJakoClen !== changeId_2; }), znalecneItems));
            if (!kancelarUstavLogged && !fopLogged)
                value[editIndex] = zpracovatelClenstvi;
            else
                value[value.findIndex(function (v) { return v.idSubjekt === changeId_2; })] = zpracovatelClenstvi;
            helpers.setValue(value);
        }
        setSelectedZpracovatel(undefined);
        setZnalciList([]);
        isOpen.setFalse();
    };
    var handleSetOsobyProfilu = function (items) {
        var withoutOsobyProfilu = value.filter(function (o) {
            return !isEdit
                ? !o.isOsobaProfilu
                : ![
                    __2.PosudkyRoleOsoby.ZpracovatelZnalecVRamciZKneboZU,
                    __2.PosudkyRoleOsoby.ZpracovatelOsobaVedeckovyzkumnaCinnostRamciZKneboZU,
                    __2.PosudkyRoleOsoby.ZpracovatelOsobaNezbytnaOdbornostVRamciZKneboZU,
                ].includes(o.role.id);
        });
        helpers.setValue(__spreadArrays(withoutOsobyProfilu, items));
        isPridatOsobyProfiluOpen.setFalse();
        setTimeout(function () {
            setOsobyProfiluList([]);
        }, 0);
    };
    var onOpenOsobyHandle = function () { return __awaiter(void 0, void 0, void 0, function () {
        var zpracovatel, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(isEdit && entityId !== (primarniIdZkZu === null || primarniIdZkZu === void 0 ? void 0 : primarniIdZkZu.toString()))) return [3 /*break*/, 2];
                    zpracovatel = value.find(function (v) { var _a; return entityId === ((_a = v.idSubjekt) === null || _a === void 0 ? void 0 : _a.toString()); });
                    setSelectedZpracovatel(zpracovatel);
                    setEditValueZpracovatel(zpracovatel);
                    return [4 /*yield*/, getZnalecClenstviJSON({ idZnalec: zpracovatel.idSubjekt })];
                case 1:
                    response = _a.sent();
                    if (__2.isRight(response))
                        setZnalciList(response.value.clenove);
                    isOpen.setTrue();
                    return [3 /*break*/, 3];
                case 2:
                    onOpenOsobyProfilu();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var prepareValues = function (formResult) {
        var newValue = {};
        var foValue = {};
        // eslint-disable-next-line no-nested-ternary
        newValue.id = formResult.id !== undefined ? formResult.id : undefined;
        if (formResult.typOsoby === __2.PosudkyTypOsoby.FyzickaOsoba) {
            newValue.jmeno = formResult.jmeno;
            newValue.prijmeni = formResult.prijmeni;
            newValue.datumNarozeni = formResult.datumNarozeni;
            newValue.adresaPobytu = formResult.adresaPobytu;
            newValue.typOsoby = formResult.typOsoby;
            newValue.role = formResult.role;
            if (formResult.idNadrazenyKonzultant !== undefined)
                newValue.idNadrazenyKonzultant = formResult.idNadrazenyKonzultant;
            if (formResult.zvlastniDilciOtazky)
                newValue.zvlastniDilciOtazky = formResult.zvlastniDilciOtazky;
            if (formResult.duvodKPribrani)
                newValue.duvodKPribrani = formResult.duvodKPribrani;
            if (formResult.titulPred)
                newValue.titulPred = formResult.titulPred;
            if (formResult.titulZa)
                newValue.titulZa = formResult.titulZa;
        }
        if (formResult.typOsoby === __2.PosudkyTypOsoby.FyzickaOsobaPodnikajici) {
            newValue.jmeno = formResult.jmeno;
            newValue.prijmeni = formResult.prijmeni;
            newValue.ico = formResult.ico.toString();
            newValue.adresaSidla = formResult.adresaSidla;
            newValue.typOsoby = formResult.typOsoby;
            newValue.role = formResult.role;
            if (formResult.titulPred)
                newValue.titulPred = formResult.titulPred;
            if (formResult.titulZa)
                newValue.titulZa = formResult.titulZa;
        }
        if (formResult.typOsoby === __2.PosudkyTypOsoby.PravnickaOsoba) {
            newValue.nazev = formResult.nazev;
            newValue.ico = formResult.ico.toString();
            newValue.adresaSidla = formResult.adresaSidla;
            newValue.typOsoby = formResult.typOsoby;
            newValue.role = formResult.role;
        }
        if (formResult.role === __2.PosudkyRoleOsoby.Konzultant) {
            newValue.zvlastniDilciOtazky = formResult.zvlastniDilciOtazky;
            newValue.duvodKPribrani = formResult.duvodKPribrani;
            if (formResult.isKanclUstavFopLogged && formResult.typOsoby === __2.PosudkyTypOsoby.PravnickaOsoba) {
                foValue.jmeno = formResult.jmeno;
                foValue.prijmeni = formResult.prijmeni;
                foValue.datumNarozeni = formResult.datumNarozeni;
                foValue.adresaPobytu = formResult.adresaPobytu;
                foValue.zvlastniDilciOtazky = formResult.zvlastniDilciOtazky;
                foValue.duvodKPribrani = formResult.duvodKPribrani;
                foValue.id = newValue.id - 1;
                foValue.idNadrazenyKonzultant = newValue.id;
                foValue.druh = { id: __2.PosudkyTypOsoby.FyzickaOsoba };
                foValue.role = { id: formResult.role };
                newValue.isNadrazenaPO = true;
                if (formResult.titulPred)
                    foValue.titulPred = formResult.titulPred;
                if (formResult.titulZa)
                    foValue.titulZa = formResult.titulZa;
            }
        }
        newValue.role = { id: formResult.role };
        newValue.druh = { id: formResult.typOsoby };
        return newValue;
    };
    var FyzickaOsobaForm = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Titul p\u0159ed jm\u00E9nem", name: "titulPred" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Titul za jm\u00E9nem", name: "titulZa" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Jm\u00E9no, p\u0159\u00EDpadn\u011B jm\u00E9na", name: "jmeno" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "P\u0159\u00EDjmen\u00ED", name: "prijmeni" })),
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Adresa bydli\u0161t\u011B", name: "adresaPobytu", placeholder: adresaPlaceHolder }),
            react_1.default.createElement(__1.DateFieldLabeled, { label: "Datum narozen\u00ED", name: "datumNarozeni", maxDate: new Date() }))));
    var handleSubmit = function (formResult, formikHelpers) { return __awaiter(void 0, void 0, void 0, function () {
        var trueIndex, newValues;
        return __generator(this, function (_a) {
            try {
                formikHelpers.setStatus(undefined);
                if (editIndex !== undefined) {
                    trueIndex = podilejiciValue.findIndex(function (v) { return v.id === formResult.id; });
                    podilejiciHelpers.setValue(ramda_1.set(ramda_1.lensIndex(trueIndex), prepareValues(formResult), podilejiciValue));
                }
                else {
                    newValues = prepareValues(formResult);
                    podilejiciHelpers.setValue(Array.isArray(newValues) ? __spreadArrays(podilejiciValue, newValues) : __spreadArrays(podilejiciValue, [newValues]));
                }
                isOpen.setFalse();
                setEditIndex(undefined);
                return [2 /*return*/];
            }
            catch (e) {
                formikHelpers.setStatus({ type: 'error', message: e.message });
            }
            return [2 /*return*/];
        });
    }); };
    var FyzickaOsobaPodnikajiciForm = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Titul p\u0159ed jm\u00E9nem", name: "titulPred" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Titul za jm\u00E9nem", name: "titulZa" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Jm\u00E9no, p\u0159\u00EDpadn\u011B jm\u00E9na", name: "jmeno" }),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "P\u0159\u00EDjmen\u00ED", name: "prijmeni" })),
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(PridatZadavateleField_1.FlexColumn, null,
                react_1.default.createElement(PridatZadavateleField_1.MarginLabel, { htmlFor: "ico" }, "I\u010CO"),
                react_1.default.createElement(__1.IcoField, { name: "ico" })),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Adresa s\u00EDdla", name: "adresaSidla", placeholder: adresaPlaceHolder }))));
    var PravnickaOsobaForm = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(__1.TextFieldLabeled, { label: "N\u00E1zev", name: "nazev" })),
        react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
            react_1.default.createElement(PridatZadavateleField_1.FlexColumn, null,
                react_1.default.createElement(PridatZadavateleField_1.MarginLabel, { htmlFor: "ico" }, "I\u010CO"),
                react_1.default.createElement(__1.IcoField, { name: "ico" })),
            react_1.default.createElement(__1.TextFieldLabeled, { label: "Adresa s\u00EDdla", name: "adresaSidla", placeholder: adresaPlaceHolder }))));
    var getForm = function (druh) {
        if (druh === __2.PosudkyTypOsoby.FyzickaOsobaPodnikajici)
            return FyzickaOsobaPodnikajiciForm;
        if (druh === __2.PosudkyTypOsoby.PravnickaOsoba)
            return PravnickaOsobaForm;
        return FyzickaOsobaForm;
    };
    var validate = function (values) {
        var jmenoLens = ramda_1.lensPath(['jmeno']);
        var prijmenilLens = ramda_1.lensPath(['prijmeni']);
        var narozeniLens = ramda_1.lensPath(['datumNarozeni']);
        var adresaPobytuLens = ramda_1.lensPath(['adresaPobytu']);
        var icoLens = ramda_1.lensPath(['ico']);
        var adresaSidlaLens = ramda_1.lensPath(['adresaSidla']);
        var nazevLens = ramda_1.lensPath(['nazev']);
        var druhLens = ramda_1.lensPath(['typOsoby']);
        var roleLens = ramda_1.lensPath(['role']);
        if (!ramda_1.view(druhLens, values)) {
            return ramda_1.pipe(ramda_1.set(druhLens, 'Typ osoby nebyl vybrán.'))({});
        }
        if (!ramda_1.view(roleLens, values)) {
            return ramda_1.pipe(ramda_1.set(roleLens, 'Role nebyla vybrána.'))({});
        }
        if (ramda_1.view(druhLens, values) === __2.PosudkyTypOsoby.FyzickaOsoba) {
            var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(jmenoLens, values); }, ramda_1.set(jmenoLens, 'Jméno je povinné')), ramda_1.when(function () { return !ramda_1.view(prijmenilLens, values); }, ramda_1.set(prijmenilLens, 'Příjmení je povinné')), ramda_1.when(function () { return !ramda_1.view(narozeniLens, values); }, ramda_1.set(narozeniLens, 'Datum narození je povinné')), ramda_1.when(function () { return !ramda_1.view(adresaPobytuLens, values); }, ramda_1.set(adresaPobytuLens, 'Adresa pobytu je povinná')))({});
            return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
        }
        if (ramda_1.view(druhLens, values) === __2.PosudkyTypOsoby.FyzickaOsobaPodnikajici) {
            var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(jmenoLens, values); }, ramda_1.set(jmenoLens, 'Jméno je povinné')), ramda_1.when(function () { return !ramda_1.view(prijmenilLens, values); }, ramda_1.set(prijmenilLens, 'Příjmení je povinné')), ramda_1.when(function () { return !ramda_1.view(icoLens, values); }, ramda_1.set(icoLens, 'IČO je povinné')), ramda_1.when(function () { return !ramda_1.view(adresaSidlaLens, values); }, ramda_1.set(adresaSidlaLens, 'Adresa sídla je povinná')))({});
            return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
        }
        if (ramda_1.view(druhLens, values) === __2.PosudkyTypOsoby.PravnickaOsoba) {
            var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(nazevLens, values); }, ramda_1.set(nazevLens, 'Název je povinný')), ramda_1.when(function () { return !ramda_1.view(icoLens, values); }, ramda_1.set(icoLens, 'IČO je povinné')), ramda_1.when(function () { return !ramda_1.view(adresaSidlaLens, values); }, ramda_1.set(adresaSidlaLens, 'Adresa sídla je povinná')))({});
            return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
        }
    };
    var onItemClick = function (id) {
        window.open("/znalec/detail/" + id);
    };
    if (loading || znalecLoad.value)
        return react_1.default.createElement(react_1.default.Fragment, null, "na\u010D\u00EDt\u00E1n\u00ED");
    return (react_1.default.createElement(__2.Field, { topAlign: true },
        ((_c = field.value) === null || _c === void 0 ? void 0 : _c.length) ? react_1.default.createElement(StyledLabel, { htmlFor: name }, label) : react_1.default.createElement(__2.FormLabel, { htmlFor: name }, label),
        react_1.default.createElement(exports.BorderDiv, { "$hasError": (!!meta.error && !field.value) || ((kancelarUstavLogged || fopLogged) && !!meta.error) },
            !!(value === null || value === void 0 ? void 0 : value.length) && (react_1.default.createElement(StyledDiv, null, utils_2.sortZpracovateByRoleId(value, entityId).map(function (item, index) {
                var _a, _b, _c, _d, _e, _f;
                return (react_1.default.createElement(ZpracovatelListItem_1.default, { key: "zpracovatel" + (item.idExterniOsoba ? 'Externi' : undefined) + "-" + (!kancelarUstavLogged && !fopLogged ? item.idSubjekt : (_a = item.idSubjekt) !== null && _a !== void 0 ? _a : item.idExterniOsoba), nazev: react_1.default.createElement("strong", null, item.nazev || utils_1.getJmenoPrijmeni(item.jmeno, item.prijmeni, item.titulPred, item.titulZa)), item: item, onRemove: function () { return handleRemoveZpracovatel(item.idSubjekt, index); }, onEdit: function () { return handleEdit(index); }, readOnly: (fopLogged || kancelarUstavLogged) && entityId === ((_c = ((_b = item.idSubjekt) !== null && _b !== void 0 ? _b : item.idExterniOsoba)) === null || _c === void 0 ? void 0 : _c.toString()), onItemClick: onItemClick, kanclUstavZnalecLogged: kancelarUstavLogged || fopLogged, editorLogged: editorLogged, isDarkBg: kancelarUstavLogged && (entityId === ((_e = ((_d = item.idSubjekt) !== null && _d !== void 0 ? _d : item.idExterniOsoba)) === null || _e === void 0 ? void 0 : _e.toString()) || entityId === ((_f = item.podiliSeJakoClen) === null || _f === void 0 ? void 0 : _f.toString())), loggedEntityId: entityId, isPrimaryZpracovatel: utils_2.isPrimaryZpracovatel(item, value) }));
            }))),
            !!(podilejiciValue === null || podilejiciValue === void 0 ? void 0 : podilejiciValue.length) && (kancelarUstavLogged || fopLogged || editorLogged) && (react_1.default.createElement(StyledDiv, null, (_e = (_d = utils_2.sortZpracovateByRoleId(podilejiciValue, entityId)) === null || _d === void 0 ? void 0 : _d.filter(function (v) {
                var _a;
                return [
                    __2.PosudkyRoleOsoby.ZnalecPodilejiciNaZpracovani,
                    __2.PosudkyRoleOsoby.OsobaZapojenaDoVedeckovyzkumneCinnosti,
                    __2.PosudkyRoleOsoby.OsobaVeSluzebnimPomeru,
                    __2.PosudkyRoleOsoby.DalsiOsoba,
                ].includes((_a = v.role) === null || _a === void 0 ? void 0 : _a.id);
            })) === null || _e === void 0 ? void 0 : _e.map(function (item, index) {
                var _a;
                return (react_1.default.createElement(SpolupracujiciOsoba_1.default, { item: item, index: index, onDelete: handleDeleteSpolupracujiciOsoba, onEdit: podilejiciEditMode, role: role, kanclUstavLogged: kancelarUstavLogged || fopLogged, onItemClick: onItemClick, loggedEntityId: entityId, isDarkBg: kancelarUstavLogged && entityId === ((_a = item.podiliSeJakoClen) === null || _a === void 0 ? void 0 : _a.toString()), editorLogged: editorLogged }));
            }))),
            kancelarUstavLogged && (react_1.default.createElement("div", null,
                react_1.default.createElement(__2.LinkButton, { type: "button", className: "button", onClick: onOpenOsobyHandle },
                    "P\u0159idat osoby z profilu ",
                    mandat === 'Znalecký ústav' ? 'znaleckého ústavu' : 'znalecké kanceláře'))),
            react_1.default.createElement(__2.LinkButton, { type: "button", className: "button", onClick: isOpen.setTrue },
                "P\u0159idat zpracovatele ",
                ((_f = value.length) !== null && _f !== void 0 ? _f : 0) > 0 && "v p\u0159\u00EDpad\u011B spole\u010Dn\u00E9ho " + (isDodatek ? 'dodatku' : 'znaleckého posudku')),
            react_1.default.createElement(StyledPopup, { open: isOpen.value, onClose: function () {
                    isOpen.setFalse();
                    setEditIndex(undefined);
                    setZnalciList([]);
                    setSelectedZpracovatel(undefined);
                    setEditValueZpracovatel(undefined);
                } },
                react_1.default.createElement(PopupChildren, null,
                    react_1.default.createElement(PridatZadavateleField_1.Title, null,
                        editIndex !== undefined ? 'Upravit' : 'Přidat',
                        " zpracovatele"),
                    react_1.default.createElement(__2.Tabs, { activeId: activeTab, onSelect: setActiveTab },
                        react_1.default.createElement(__2.Tabs.Tab, { id: "clenstvi", title: "Znalec / kancel\u00E1\u0159 / \u00FAstav" }, selectedZpracovatel ? (react_1.default.createElement(PridatPodilejiciOsobuPopup_1.PridatPodilejiciOsobuPopup, { addPodilejiciSe: handleSetPodilejci, znalciList: znalciList, selectedZpracovatel: selectedZpracovatel, selectedPodilejici: (editValueZpracovatel === null || editValueZpracovatel === void 0 ? void 0 : editValueZpracovatel.idSubjekt) === selectedZpracovatel.idSubjekt
                                ? podilejiciValue.filter(function (s) { return s.podiliSeJakoClen === (editValueZpracovatel === null || editValueZpracovatel === void 0 ? void 0 : editValueZpracovatel.idSubjekt); })
                                : undefined })) : (react_1.default.createElement(PridatZpracovatelePopup_1.default, { addZpracovatel: handleAddZpracovatel, zpracovatele: __spreadArrays(value, podilejiciValue.filter(function (po) {
                                return po.role.id === __2.PosudkyRoleOsoby.ZnaleckaKancelarPodilejiciNaZpracovani ||
                                    po.role.id === __2.PosudkyRoleOsoby.ZnaleckyUstavPodilejiciNaZpracovani ||
                                    (po.role.id === __2.PosudkyRoleOsoby.ZnalecPodilejiciNaZpracovani && !po.podiliSeJakoClen);
                            })), datumZadani: datumZadani, selectedZpracovatel: editValueZpracovatel }))),
                        react_1.default.createElement(__2.Tabs.Tab, { id: "adhoc", title: "Jin\u00E1 osoba / Ad Hoc znalec" },
                            react_1.default.createElement(Form_1.default, { initialValues: editValueZpracovatel ? __assign(__assign({}, editValueZpracovatel), { role: editValueZpracovatel.role.id, typOsoby: editValueZpracovatel.druh.id }) : {}, onSubmit: handleSubmit, validate: validate }, function (_a) {
                                var isSubmitting = _a.isSubmitting, values = _a.values, setFieldValue = _a.setFieldValue;
                                if (((kancelarUstavLogged || fopLogged) && values.role !== __2.PosudkyRoleOsoby.DalsiOsoba) ||
                                    ((kancelarUstavLogged || fopLogged) && !values.isKanclUstavFopLogged)) {
                                    setFieldValue('role', __2.PosudkyRoleOsoby.DalsiOsoba);
                                    setFieldValue('isKanclUstavFopLogged', kancelarUstavLogged || fopLogged);
                                }
                                return (react_1.default.createElement(PopupDiv, null,
                                    react_1.default.createElement(__2.Padder, null,
                                        react_1.default.createElement(react_1.default.Fragment, null,
                                            react_1.default.createElement(StyledLabel, null, "Typ osoby"),
                                            react_1.default.createElement(PridatZadavateleField_1.CoupledFields, null,
                                                react_1.default.createElement(StyledDiv, null,
                                                    react_1.default.createElement(SelectTypOsoby_1.default, { name: "typOsoby", filterResult: function (_a) {
                                                            var id = _a.id;
                                                            return id !== __2.PosudkyTypOsoby.OVM;
                                                        } })))),
                                        getForm(values.typOsoby),
                                        react_1.default.createElement(PridatPodilejiciOsobuPopup_1.CenteredDiv, null,
                                            react_1.default.createElement(__2.Button, { type: "submit", primary: true, loading: isSubmitting, name: "pridatSpolupracujiciOsobu" }, editIndex !== undefined ? 'ULOŽIT ZMĚNY' : 'PŘIDAT OSOBU')))));
                            })),
                        react_1.default.createElement(react_1.default.Fragment, null)))),
            react_1.default.createElement(StyledPopup, { open: isPridatOsobyProfiluOpen.value, onClose: onCloseOsobyProfilu },
                react_1.default.createElement(PridatZadavateleField_1.Title, null,
                    editIndex !== undefined ? 'Upravit' : 'Přidat',
                    " zpracovatele"),
                react_1.default.createElement(PridatOsobyProfiluPopup_1.PridatOsobyProfiluPopup, { addOsobyProfilu: handleSetOsobyProfilu, selectedKanclUstav: selectedKanclUstav, znalciList: osobyProfiluList, onClose: onCloseOsobyProfilu, selectedOsoby: value.filter(function (s) {
                        return !isEdit
                            ? s.isOsobaProfilu
                            : [
                                __2.PosudkyRoleOsoby.ZpracovatelZnalecVRamciZKneboZU,
                                __2.PosudkyRoleOsoby.ZpracovatelOsobaVedeckovyzkumnaCinnostRamciZKneboZU,
                                __2.PosudkyRoleOsoby.ZpracovatelOsobaNezbytnaOdbornostVRamciZKneboZU,
                            ].includes(s.role.id);
                    }), clenstviLoad: clenstviLoad.value, primarniIdZkZu: primarniIdZkZu })))));
};
PridatZpracovateleField.defaultProps = {
    datumZadani: undefined,
    isEdit: false,
    isDodatek: undefined,
};
exports.default = PridatZpracovateleField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
